import { $PrismaAuditLogDto, PrismaAuditLogDto } from 'app/API';

export type TAuditActorType = PrismaAuditLogDto['actorType'];

export const auditActorTypes: readonly TAuditActorType[] = $PrismaAuditLogDto.properties.actorType.enum;
